import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
import { CommonModule, CurrencyPipe} from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSliderModule } from '@angular/material/slider';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import {MatSelectModule} from '@angular/material/select';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatCardModule} from '@angular/material/card';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import { FormsModule, ReactiveFormsModule  } from '@angular/forms';
import { AgmCoreModule } from '@agm/core';
import { MatGoogleMapsAutocompleteModule } from '@angular-material-extensions/google-maps-autocomplete';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MainComponent } from './main/main.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { ArtHausComponent } from './art-haus/art-haus.component';
import { ArtWohnungComponent } from './art-wohnung/art-wohnung.component';
import { FormDataService }    from './data/formData.service';
import { WorkflowService }    from './workflow/workflow.service';
import { ArtHausStep2Component } from './art-haus-step2/art-haus-step2.component';
import { ArtHausStep3Component } from './art-haus-step3/art-haus-step3.component';
import { ArtHausStep4Component } from './art-haus-step4/art-haus-step4.component';
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import { ArtHausStep5Component } from './art-haus-step5/art-haus-step5.component';
import { FinalComponent } from './final/final.component';
import { ArtWohnungStep2Component } from './art-wohnung-step2/art-wohnung-step2.component';
import { ArtWohnungStep3Component } from './art-wohnung-step3/art-wohnung-step3.component';
import { ArtWohnungStep4Component } from './art-wohnung-step4/art-wohnung-step4.component';
import { ArtWohnungStep5Component } from './art-wohnung-step5/art-wohnung-step5.component';
import { HttpClientModule } from '@angular/common/http';
import { SpinnerComponent } from './spinner/spinner.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { SizePipe } from './size.pipe';

registerLocaleData(localeDe);

@NgModule({
  declarations: [
    AppComponent,
    MainComponent,
    HeaderComponent,
    FooterComponent,
    ArtHausComponent,
    ArtWohnungComponent,
    ArtHausStep2Component,
    ArtHausStep3Component,
    ArtHausStep4Component,
    ArtHausStep5Component,
    FinalComponent,
    ArtWohnungStep2Component,
    ArtWohnungStep3Component,
    ArtWohnungStep4Component,
    ArtWohnungStep5Component,
    SpinnerComponent,
    SizePipe
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MatSliderModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    MatCardModule,
    MatCheckboxModule,
    MatProgressBarModule,
    FlexLayoutModule,
    // important !!!
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyAh8Tq_Qgqq5PrEDQOc7_n9GENmr_qrfyY',
      libraries: ['places']
    }),
  MatGoogleMapsAutocompleteModule
  ],
  providers:    [{ provide: FormDataService, useClass: FormDataService },
    { provide: WorkflowService, useClass: WorkflowService }, 
    CurrencyPipe,
    { provide: LOCALE_ID, useValue: 'de'}],
  bootstrap: [AppComponent]
})
export class AppModule { }